import React from 'react';
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FieldProgress = () => {
  const {
    i18n
  } = useLingui();
  const subtext = i18n._('carlead.progress.subtext');
  return /*#__PURE__*/_jsxs("div", {
    className: "progress pie",
    "data-tracking": true,
    "data-action": "Click",
    "data-category": "Lead",
    "data-label": "progress pie",
    children: [/*#__PURE__*/_jsx("div", {
      className: "progress--pie",
      children: /*#__PURE__*/_jsx("div", {
        className: "progress--overlay"
      })
    }), subtext && /*#__PURE__*/_jsx("p", {
      className: "progress__subtext",
      children: subtext
    })]
  });
};
export default FieldProgress;